import { render } from "./SearchForm.vue?vue&type=template&id=19f6812d"
import script from "./SearchForm.vue?vue&type=script&lang=ts"
export * from "./SearchForm.vue?vue&type=script&lang=ts"
script.render = render

export default script